import React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import boy400 from "../shared/images/boy400.png";
import { JoinButton } from "../header/style";
import { Link, Button, animateScroll as scroll, scrollSpy } from "react-scroll";
import Signup from "../Signup";

const Introduction = () => {
  return (
    <Box
      component="section"
      sx={{
        // border: "1px dashed grey",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "8rem",
        paddingBottom: "6rem",
        // paddingLeft: "14rem",
        // backgroundColor: "#e8eaf6",
        // padding: "10%",
      }}
    >
      <Box
        component="section"
        sx={{
          // border: "1px dashed grey",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          // paddingLeft: "10.3rem",

          // backgroundColor: "#e8eaf6",
          // padding: "10%",
        }}
      >
        <Typography
          variant="h6"
          component="h1"
          sx={{
            fontWeight: "bold",
            color: "black",
            fontSize: "4.2rem",
            lineHeight: "1.1",
          }}
        >
          Supercharge your learning
        </Typography>
        <Typography
          variant="h6"
          component="h1"
          sx={{
            // fontWeight: "bold",
            fontWeight: 500,
            color: "black",
            fontSize: "1.5rem",
            marginBottom: "2rem",
          }}
        >
          Practice. Learn. Succeed. Just deep, personalized techniques powered
          by AI
        </Typography>
        {/* <Link to="section1" smooth={true} duration={500}> */}
        {/* <JoinButton>Start your journey</JoinButton> */}
        <Signup />
        {/* </Link> */}
      </Box>
      <Box sx={{ paddingLeft: "2rem" }}>
        <img
          height="370px"
          width="200px"
          src={boy400}
          alt="img"
          loading="lazy"
        />
      </Box>
    </Box>
  );
};

export default Introduction;
